import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setCoins, setAddresses, setRate } from './coinSlice';

export const FetchCoinRates = () => {
  const dispatch = useDispatch();

    // Prices come from coin_rate_changes (filled by server cron). No external API calls here.
    const { isLoading: isloadingCoins, refetch: fetchCoins } = useQuery(
        "get-coin-rate",
        async () => {
          return await apiClient.get("/api/get-coin-rate");
        },
        {
          enabled: true,
          refetchInterval: 60000,
          refetchIntervalInBackground: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
              dispatch(setCoins(res.data.coins))
              dispatch(setAddresses(res.data.addresses))
              
              dispatch(setRate(res.data.coin_rate))             
              
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        fetchCoins();
      }, []);
 
}

export default FetchCoinRates
